import { Component, OnInit } from '@angular/core';
import { PageService } from 'src/app/services/page.service';

@Component({
    selector: 'app-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent implements OnInit {
    loadOverlay: boolean = false;
    overlayImage: string;

    constructor(private pageService: PageService) {
        // this.pageService.overlayImage.subscribe((image: string) => {
        //     if(image != ''){
        //         this.enableOverlay(image)
        //     } else {
        //         this.disableOverlay();
        //     }
        // })
    }

    ngOnInit() {
    }

    enableOverlay(imageUrl) {
        this.overlayImage = imageUrl;
        this.loadOverlay = true;
    }
    
    disableOverlay() {
        this.loadOverlay = false;
        this.overlayImage = '';
    }
}
